import { getDaysDifferenceAbs } from "../../../lib/dateScripts";
import { formatDateLocal } from "../../../lib/script";
import DaysAgoBox from "./DaysAgoBox";

export default function DateWithBox({classes, date}) {
    return <div className={`${classes.cell_row} ${classes.cell_row_flex} ${classes.cell_row_flex_betwen}`}>
        {date ? <>
            {formatDateLocal(date)} 
            <DaysAgoBox days={getDaysDifferenceAbs(date)} />
        </>
        :
        <>-</>
        }
    </div>
}